import React from 'react';
import { Card } from '../../../../../components/ui/card';
import { 
  Calendar,
  MapPin,
  User,
  Building2,
  Activity,
  Wrench,
  Cable,
  FileText,
  Shield,
  Flame
} from 'lucide-react';
import type { DashboardProject } from '../../../types/project';
import { BasicInfo } from './components/BasicInfo';
import { PipelineTypeSection } from './components/PipelineTypeSection';
import { FabricationTypeSection } from './components/FabricationTypeSection';
import { OtherTypeSection } from './components/OtherTypeSection';


interface ProjectOverviewProps {
  project: DashboardProject;
}

export const ProjectOverview: React.FC<ProjectOverviewProps> = ({ project }) => {
  const getStatusColor = (status: DashboardProject['status']) => {
    const colors = {
      'active': 'bg-green-100 text-green-800',
      'completed': 'bg-blue-100 text-blue-800',
      'on-hold': 'bg-yellow-100 text-yellow-800',
      'cancelled': 'bg-red-100 text-red-800'
    } as const;
    return colors[status] || 'bg-gray-100 text-gray-800';
  };

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="space-y-6 space-x-6">
      {/* Basic Information */}
      <BasicInfo project={project} />

      {/* Project Types */}
      <Card className="p-6" style={{ marginLeft: '20px', marginRight: '20px' }}>
        <h3 className="text-lg font-semibold mb-6">Project Types</h3>
        <div className="space-y-8">
          {/* Project Type Badges */}
          <div>
            <p className="text-sm text-gray-500 mb-3">Selected Types</p>
            <div className="flex flex-wrap gap-2">
              {project.projectTypes.pipeline && (
                <div className="px-3 py-2 bg-blue-100 text-blue-800 rounded-md flex items-center gap-2">
                  <Cable className="h-4 w-4" />
                  Pipeline
                </div>
              )}
              {project.projectTypes.fabrication && (
                <div className="px-3 py-2 bg-purple-100 text-purple-800 rounded-md flex items-center gap-2">
                  <Wrench className="h-4 w-4" />
                  Fabrication
                </div>
              )}
             
            </div>
          </div>
          <PipelineTypeSection project={project} />
          <FabricationTypeSection project={project} />
        </div>
      </Card>
    </div>
  );
};